var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "change" }, [
    _c("footer", [
      _c("div", { staticClass: "inner" }, [
        _c("section", { staticClass: "contact" }, [
          _c("p", [
            _vm._v(
              "お問い合わせは下記フォームからお願いいたします。お電話でのお問い合わせも承っております。お気軽にご相談ください。"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "button" }, [
            _c("a", { staticStyle: { border: "none" } }),
            _vm._v(" "),
            _c("a", { attrs: { href: "javascript:void(p);", id: "btn_tel" } }, [
              _c("picture", [
                _c("source", {
                  attrs: {
                    srcset: _vm.getImage("footer/btn_tel_footer.png"),
                    type: "image/png",
                    media: "(min-width: 700px)"
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: _vm.getImage("footer/btn_tel_footer.png"),
                    type: "image/png",
                    alt: "電話"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("a", { staticStyle: { border: "none" } })
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "sitemap" }, [
          _c("div", { staticClass: "logo_space" }, [
            _c("div", { staticClass: "mm_logo" }),
            _vm._v(" "),
            _c("div", { staticClass: "sns_icon" }, [
              _c("a", { staticClass: "instagram", attrs: { href: "/" } }, [
                _c("picture", [
                  _c("source", {
                    attrs: {
                      srcset: _vm.getImage(
                        "footer/Instagram_Glyph_White_360.png"
                      ),
                      type: "image/png",
                      media: "(min-width: 700px)"
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: _vm.getImage("footer/Instagram_Glyph_White_360.png"),
                      type: "image/png",
                      alt: "Instagram"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("a", { staticClass: "facebook", attrs: { href: "/" } }, [
                _c("picture", [
                  _c("source", {
                    attrs: {
                      srcset: _vm.getImage("footer/f_logo_RGB-White_250.png"),
                      type: "image/png",
                      media: "(min-width: 700px)"
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: _vm.getImage("footer/f_logo_RGB-White_250.png"),
                      type: "image/png",
                      alt: "facebook"
                    }
                  })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "menu_space" })
        ]),
        _vm._v(" "),
        _vm._m(0)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "copyright" }, [
      _c("p", [_vm._v("Copyright ©2024 domans all rights reserved.")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e304aca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e304aca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/Footer.vue
// module id = null
// module chunks = 